import { LoadingSpinner } from './loading-spinner.tsx';

export const LoadingBlockFullScreen: React.FC = () => {
    return (
        <div className="flex h-dvh w-screen items-center justify-center">
            <LoadingSpinner />
        </div>
    );
};
